export default "__VITE_ASSET__BYy4fesH__"